package org.teddapp.project.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.SideEffect

/**
 * Compteurs de recompositions, pour mesurer avant de corriger. Inertes tant que
 * [enabled] est faux : en production, une sonde ne coûte qu'un test de booléen.
 *
 * Les bancs de performance (`PerfBenchTest` sur le bureau) activent le traceur,
 * jouent un scénario et lisent les compteurs.
 *
 * Tout se passe sur le fil de composition, et le banc lit entre deux images : pas
 * de verrou, le code reste commun à toutes les plateformes.
 */
object TeddTrace {
    var enabled: Boolean = false

    private val counts = HashMap<String, Int>()

    /** Une recomposition de plus pour [tag]. */
    fun hit(tag: String) {
        if (!enabled) return
        counts[tag] = (counts[tag] ?: 0) + 1
    }

    fun count(tag: String): Int = counts[tag] ?: 0

    /** Tous les compteurs, triés par nom. */
    fun snapshot(): Map<String, Int> = counts.entries.sortedBy { it.key }.associate { it.key to it.value }

    fun reset() = counts.clear()
}

/** Compte une recomposition de l'endroit où elle est posée, sous [tag]. */
@Composable
fun RecompositionProbe(tag: String) {
    if (TeddTrace.enabled) SideEffect { TeddTrace.hit(tag) }
}
